import { useMutation, useQueryClient } from 'react-query';
import { useContext } from 'react';
import { FetchContext } from 'context/FetchContext';

function useDeletePlayable(podcastId, episodeId) {
  const queryClient = useQueryClient();
  const { privateFetch } = useContext(FetchContext);

  return useMutation(
    async (playableId) => {
      const res = await privateFetch.delete(
        `/v1/admin/podcast/${podcastId}/episode/${episodeId}/playable/${playableId}`
      );
      return res.data;
    },
    {
      onSuccess: () => {
        queryClient.invalidateQueries(['episode-playable', podcastId, episodeId]);
      },
      onError: (error) => {
        console.error('Failed to delete playable:', error);
      },
    }
  );
}

export default useDeletePlayable;
